module.exports = __webpack_public_path__ + "a3fd1cc75ad6831f4436f45eaea5ce29.MP3";